export const fleeceSlides = [
    { src: "assets/fleece_1.jpg" },
    { src: "assets/fleece_2.jpg" },
];

export const fleeceVideo = [
    {
        type: "video",
        poster: "assets/fleece_3.jpg",
        sources: [
            {
            src:
                "assets/fleece_barleritz.mp4",
            type: "video/mp4"
            }
        ]
    }
];

export const ephemSlides = [
    { src: "assets/ephem_1.jpg" },
    { src: "assets/ephem_2.jpg" },
];

export const llSlides = [
    { src: "assets/ll_homepage.png" },
    { src: "assets/ll_collection.png" },
    { src: "assets/ll_product.png" }
];

export const concordiaSlides = [
    { src: "assets/concordia_campus.jpg" }
];